module.exports = __webpack_public_path__ + "images/application/credit-cards-59a66cea.svg";